import {gql, useLazyQuery} from "@apollo/client";

const GET_DATA = gql`
query TeamsToNextStage($stageId: Int!) {
    teamsToNextStage(stageId: $stageId){
        teamId
        teamName
        qualification
        played
        win
        draw
        lose
        scoreFor
        scoreAgainst
        scoreDifference
        points
        groupName
    }
}
`;

export default function GetTeamsToNextStage() {
    return useLazyQuery(GET_DATA);
};
